import * as React from "react";
import { merge, $ } from "glamor";
import { format } from "lib/globalize-util";
import { Map } from "immutable";
import classNames from "classnames";
import Paper from "@material-ui/core/Paper";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import debounce from "lodash/debounce";
import theme from "styles/theme";
import Downshift from "downshift";
import {
    getFilteredSuggestions,
    markupGenerator,
    IRenderSuggestionProps,
} from "../product-collection-grid-view/grid-editors/editor-helper";
import _ from "lodash";
import { feLookupTypeGetter } from "helpers/product-collection";
import { IDependency } from "helpers/merchant/lookup/types";
interface IFieldProps {
    value: string;
    field: Map<string, any>;
    readOnly: boolean;
    onChange: any;
    onKeyDown: (e) => void;
    allowedValueFields: any;
    item: Map<string, any>;
    dataGetter: (value: string, data: string[]) => string;
    handleGoToNextField: (field: Map<string, any>, backward?: boolean) => void;
    freeform: boolean;
}

interface IState {
    focus: boolean;
    inputValue: string;
    displayValue: string;
    highLightIndex: number | null;
    rawData: any[];
    displaySuggestions: string[];
    filteredDisplaySuggestions: string[];
    dependency: IDependency;
}
const KEY_DOWN = 40;
const KEY_UP = 38;
const FIELD_HEIGHT = 40;
// NOTE: Not available now NU-4157
export class NuorderSelectField extends React.PureComponent<IFieldProps, IState> {
    private editor;
    private _unmounted: boolean = false;
    private styles = merge(
        $(".fieldContainer .paper", {
            overflow: "auto",
            height: "200px",
            width: "100%",
            border: `1px solid ${theme.palette.borderColor}`,
            position: "absolute",
            zIndex: "999",
        }),
        $(".fieldContainer .container", {
            padding: "0px",
        }),
        $(".fieldContainer .MuiInput-root", {
            padding: "0px",
            height: `${FIELD_HEIGHT}px`,
        }),
        $(".fieldContainer .MuiInput-root:hover", {
            backgroundColor: `${theme.palette.alternateTextColor}`,
        }),
        $(".fieldContainer .Mui-focused", {
            backgroundColor: `${theme.palette.editing} !important`,
        }),
        $(".fieldContainer .MuiInput-underline:before", {
            borderWidth: "0px !important",
        }),
        $(".fieldContainer .MuiInput-underline:after", {
            borderWidth: "0px !important",
        }),
        $(".fieldContainer .inputBox", {
            fontSize: "14px",
        }),
        $(".fieldContainer .displayValue", {
            lineHeight: `${FIELD_HEIGHT}px`,
            padding: "0 0 0 11px !important",
            fontSize: "14px",
        })
    );
    constructor(props) {
        super(props);
        this.state = {
            focus: false,
            inputValue: props.value || "",
            displayValue: props.value || "",
            highLightIndex: null,
            rawData: [],
            displaySuggestions: [],
            filteredDisplaySuggestions: [],
            dependency: {},
        };
    }

    componentDidMount() {
        // NOTE here we will make api call to get the data if not provided
        const { allowedValueFields, field } = this.props;
        const { inputValue } = this.state;
        const fieldName = field.get("field_name");
        const suggestions = allowedValueFields[fieldName];
        if (suggestions && suggestions.length > 0) {
            const filteredDisplaySuggestions = getFilteredSuggestions(inputValue, suggestions);
            this.setState({
                displaySuggestions: suggestions,
                filteredDisplaySuggestions,
            });
        } else {
            this.setSuggestionFromURL();
        }
    }
    componentDidUpdate(prevProps) {
        const { item } = this.props;
        if (!_.isEqual(prevProps.item.toJS(), item.toJS())) {
            this.setSuggestionFromURL();
        }
    }
    componentWillUnmount() {
        this._unmounted = true;
    }

    setSuggestionFromURL() {
        const { field, item } = this.props;
        const { inputValue } = this.state;
        const { feLookupUrl, dependency } = feLookupTypeGetter(field.toJS())(item.toJS().fields);
        this.setState({
            dependency,
        });
        const options = {
            method: "GET",
        };
        fetch(feLookupUrl, options)
            .then((response) => response.json())
            .then((data) => {
                if (!this._unmounted && data && !data.status) {
                    let displayData = data;
                    if (typeof data[0] === "object") {
                        displayData = data.map((sug) => sug.Value);
                    }
                    const displayValue = data.find((res) => res.Code === inputValue);

                    const filteredDisplaySuggestions = getFilteredSuggestions(inputValue, displayData);
                    this.setState({
                        rawData: data,
                        displaySuggestions: displayData,
                        filteredDisplaySuggestions,
                        displayValue: displayValue ? displayValue.Value : this.props.value,
                    });
                } else {
                    this.setState({
                        rawData: [],
                        displaySuggestions: [],
                        filteredDisplaySuggestions: [],
                    });
                }
            })
            .catch((error) => {
                this.setState({
                    rawData: [],
                    displaySuggestions: [],
                    filteredDisplaySuggestions: [],
                });
            });
    }

    renderInput(inputProps) {
        const { field } = this.props;
        const { InputProps, ref, ...other } = inputProps;
        const fieldName = field.get("field_name");
        let otherProps = {
            ...other,
        };
        if (!this.state.focus) {
            otherProps = {
                ...otherProps,
                inputProps: {
                    // NOTE: show displayValue instead of what we store.
                    value: this.state.displayValue,
                },
            };
        }
        return (
            <TextField
                name={fieldName}
                inputRef={this.bindEditor}
                InputProps={{
                    classes: {
                        root: "inputField",
                        input: "inputBox",
                    },
                    ...InputProps,
                }}
                {...otherProps}
            />
        );
    }

    renderSuggestion(suggestionProps: IRenderSuggestionProps) {
        const { suggestion, index, itemProps, highlightedIndex } = suggestionProps;
        const { inputValue, rawData } = this.state;
        const trimedInputValue = inputValue ? inputValue.trim() : "";
        const markup = markupGenerator(trimedInputValue, suggestion);
        const { onClick } = itemProps;
        const suggestionOnClick = (e) => {
            const displayValue = e.target.textContent;
            const newInputValue = rawData.find((item) => item.Value === displayValue).Code;
            this.setState({
                displayValue,
                inputValue: newInputValue,
            });
            onClick(e);
        };
        return (
            <MenuItem
                {...itemProps}
                onClick={suggestionOnClick}
                key={suggestion}
                component="div"
                style={{
                    backgroundColor:
                        highlightedIndex === index ? theme.palette.selectedOptionBackground : theme.palette.canvasColor,
                    whiteSpace: "normal",
                }}
            >
                {trimedInputValue === "" ? suggestion : markup}
            </MenuItem>
        );
    }

    handleInputKeyDown(highlightedIndex, event) {
        const { filteredDisplaySuggestions } = this.state;
        let index = highlightedIndex;

        if (event.keyCode === KEY_DOWN) {
            if (index === null || index === filteredDisplaySuggestions.length - 1) {
                index = 0;
            } else {
                index = index + 1;
            }
        } else if (event.keyCode === KEY_UP) {
            if (index === null || index === 0) {
                index = filteredDisplaySuggestions.length - 1;
            } else {
                index = index - 1;
            }
        }
        this.setState({
            highLightIndex: index,
        });
    }

    handleInputChange(event: React.ChangeEvent<{ value: string }>) {
        const newInputValue = event.target.value;
        const { displaySuggestions } = this.state;
        const newFilteredDisplaySuggestions = getFilteredSuggestions(newInputValue, displaySuggestions);
        this.setState({
            inputValue: newInputValue,
            filteredDisplaySuggestions: newFilteredDisplaySuggestions,
        });
    }

    render() {
        const { field, readOnly, value, onKeyDown } = this.props;
        const { inputValue, focus } = this.state;
        const headerName = field.get("display_name");
        return (
            <div className={classNames("fieldContainer", { isFocused: focus, editable: !readOnly })} {...this.styles}>
                <span className="fieldLabel">{headerName}</span>
                {!readOnly && (
                    <div onClick={this.handleClick} className="inputContainer" onKeyDown={onKeyDown}>
                        <Downshift inputValue={inputValue || ""} initialIsOpen={false} onChange={this.handleChange}>
                            {({ getInputProps, getItemProps, getLabelProps, highlightedIndex, isOpen, openMenu }) => {
                                const { highLightIndex, filteredDisplaySuggestions } = this.state;
                                const placeholderText =
                                    highLightIndex !== null
                                        ? filteredDisplaySuggestions[highLightIndex]
                                        : format("Enter |headerName|", { headerName });
                                const { onBlur, onChange, onFocus, ...inputProps } = getInputProps({
                                    onKeyDown: this.handleInputKeyDown.bind(this, highlightedIndex),
                                    placeholder: placeholderText,
                                    onFocus: () => {
                                        this.setState({ focus: true });
                                        openMenu();
                                    },
                                    onBlur: this.onBlur,
                                });
                                return (
                                    <div className="container" style={{ width: "100%" }}>
                                        {this.renderInput({
                                            fullWidth: true,
                                            InputLabelProps: getLabelProps(),
                                            InputProps: {
                                                startAdornment: [],
                                                onBlur,
                                                onChange: (event) => {
                                                    this.handleInputChange(event);
                                                    onChange(event as React.ChangeEvent<HTMLInputElement>);
                                                },
                                                onFocus,
                                            },
                                            inputProps,
                                        })}
                                        {filteredDisplaySuggestions.length > 0 && isOpen ? (
                                            <div className="options" style={{ width: "100%" }}>
                                                <Paper
                                                    className="paper"
                                                    square={true}
                                                    style={{
                                                        width: this.editor ? `${this.editor.offsetWidth}px` : "100%",
                                                    }}
                                                >
                                                    {filteredDisplaySuggestions.map((suggestion, index) =>
                                                        this.renderSuggestion({
                                                            suggestion,
                                                            index,
                                                            itemProps: getItemProps({ item: suggestion }),
                                                            highlightedIndex:
                                                                highlightedIndex === null ? -1 : highlightedIndex,
                                                        })
                                                    )}
                                                </Paper>
                                            </div>
                                        ) : null}
                                    </div>
                                );
                            }}
                        </Downshift>
                    </div>
                )}
                {readOnly && <span className="fieldValue nonEditable">{value}</span>}
            </div>
        );
    }

    private handleClick = () => {
        process.nextTick(() => {
            if (this.editor && !this.state.focus) {
                this.editor.focus();
            }
        });
    };

    private bindEditor = (ref) => (this.editor = ref);

    private handleChange = (item) => {
        const { dataGetter, field } = this.props;
        const { rawData } = this.state;
        let newInputValue = item;
        if (dataGetter) {
            newInputValue = dataGetter(item, rawData);
        }
        this.setState({
            inputValue: newInputValue,
            displayValue: item,
        });
        process.nextTick(() => this.props.handleGoToNextField(field));
    };
    private onBlur = () => {
        this.setState({
            focus: false,
        });
        const { inputValue, filteredDisplaySuggestions, rawData } = this.state;
        const { field, freeform, dataGetter } = this.props;
        let rawValue = inputValue;
        if (filteredDisplaySuggestions.length === 1 && inputValue.length > 0) {
            rawValue = filteredDisplaySuggestions[0];
            this.setState({
                displayValue: filteredDisplaySuggestions[0],
            });
        }
        let returnValue = rawValue;
        if (dataGetter) {
            const code = dataGetter(rawValue, rawData);
            if (code !== undefined) {
                returnValue = code;
            } else {
                if (freeform) {
                    returnValue = inputValue;
                } else {
                    returnValue = this.props.value;
                }
            }
        }
        this.setState({
            inputValue: returnValue,
        });
        this.handleSaveChanges({ value: returnValue, field });
    };

    // tslint:disable-next-line: member-ordering
    private handleSaveChanges = debounce(({ value, field }) => this.props.onChange({ value, field }), 100);
}
